/**
 * SAIL CUSTOM — Global keyboard-focus detection
 *
 * Adds `mouse-focused` to any element focused via pointer (click/touch),
 * so CSS can suppress the focus ring on those elements while keeping it
 * for keyboard (Tab) navigation.
 */

let lastInteractionWasMouse = false;

document.addEventListener('pointerdown', () => {
  lastInteractionWasMouse = true;
}, { capture: true });

document.addEventListener('focus', (event) => {
  if (lastInteractionWasMouse) {
    /** @type {Element} */ (event.target).classList?.add('mouse-focused');
  }
  lastInteractionWasMouse = false;
}, { capture: true });

document.addEventListener('blur', (event) => {
  /** @type {Element} */ (event.target).classList?.remove('mouse-focused');
}, { capture: true });
